import React from "react";
import Slider from "../components/Slider/Slider";

const IndexPage = () => <Slider />;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js